<template>
  <div id="app" :class="pageTheme" class="app-container b-2-cl">
    <c-tip/>
    <Header></Header>
    <c-header :class="headClass" v-show="false"/>
    <div
      class="page-content"
      :class="{'page-content-chain' : hideheade || navigationType === '1'}"
      style="position: relative; min-height: calc(100vh - 165px)">
        <router-view />
    </div>
    <Footer :class="footerClass" v-show="!hideFooter"/>
  </div>
</template>

<script>
import commonMixin from 'BlockChain-ui-privatization/PC/pages/pages';
// import { getCookie } from '@/utils';
import { getUpDownMode } from '@/utils/storage';
import Header from '@/components/layout/Header.vue';
// eslint-disable-next-line import/no-unresolved
import Footer from '@/components/layout/Footer.vue';

// 1黑色版 2白色版
// if (getCookie('cusSkin') === '2') {
//   // eslint-disable-next-line no-unused-expressions
//   import ('BlockChain-ui-privatization/static/css/color-white.styl');
// }

export default {
  mixins: [commonMixin],
  components: {
    Header,
    Footer,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setTailwindTheme();
      this.$bus.$on('outUserIsLogin', () => {
      // 清除登录状态
        this.$store.dispatch('deleteIsLogin');
        // 如果当前页面需要登录 则跳转到登录
        if (this.$route.meta.mustLogin) {
          // this.$router.push('/login');
          const currentHost = process.env.VUE_APP_COMPILE_ENV === 'prod' ? 'https://mal.io/' : 'https://test.mal.coffee:8734/';
          window.location.href = `${currentHost}login?redirect=${window.location.href}`;
        }
      });
      this.setStyle();
      this.timing();
      document.addEventListener(
        'mousewheel',
        () => {
          this.setTiming();
          this.reload();
        },
        false,
      );
      document.addEventListener(
        'click',
        () => {
          this.setTiming();
          this.reload();
        },
        false,
      );
      document.addEventListener(
        'mousemove',
        () => {
          this.setTiming();
          this.reload();
        },
        false,
      );
      document.addEventListener(
        'keydown',
        () => {
          this.setTiming();
          this.reload();
        },
        false,
      );
      // 获取 public-info 数据
      this.$store.dispatch('getPublicInfo');
      this.$store.dispatch('getAppDownload');
      // 获取 userinfo
      this.$store.dispatch('getUserInfo');
      // 获取自定义footer 和 自定义header
      // this.$store.dispatch('getFooterHeander_info');

      // if (this.loginFlag === '2') {
      //   clearInterval(this.timer);
      //   this.$store.dispatch('getMessage_count');
      //   this.timer = setInterval(() => {
      //     this.$store.dispatch('getMessage_count');
      //   }, 15000);
      // } else {
      //   clearInterval(this.timer);
      // }
    },

    /**
     * windicss定义黑暗模式和半天模式 && 涨跌颜色
     * 1黑 2白
     * red_up_green_down: '红涨绿跌'  green_up_red_down: '绿涨红跌'
     */
    setTailwindTheme() {
      document.body.classList.add('dark');
      // if (getCookie('cusSkin') === '1') {
      //   document.body.classList.add('dark');
      // } else {
      //   document.body.classList.add('light');
      // }

      // 涨跌颜色
      const colorMode = getUpDownMode();
      document.documentElement.classList.add(colorMode);
    },
  },
};
</script>
<style lang="scss">
// @import '~@/assets/font/font.scss';
// @import '~@/assets/css/common.scss';
.app-container {
  position: relative;
  min-height: 800px;
  min-width:1440px;
  background: #161a23!important;
}

@media only screen and (max-width: 769px) {
  .app-container {
    position: relative;
    min-height: 800px;
    min-width: auto;
  }
}
</style>
